export const PORTAL_FRONTEND_VERSION = '2.32.0';
export const ADMIN_FRONTEND_VERSION = '1.1.0';
